(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/views/drawselector-header.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/views/drawselector-header.js');


'use strict';

const DrawselectorHeader = Marionette.View.extend({
  events: {
    click: 'toggleDrawMenu'
  },
  template: data => svs.sport.drawselector.templates.drawselector_header(data),
  initialize(options) {
    this.model.set('branding', options.branding);
  },
  toggleDrawMenu() {
    if (this.model.get('disableSlideDown')) {
      return;
    }
    const menuIsOpen = $('.js-caret').hasClass('icon-menu-up');
    if (menuIsOpen) {
      $('.js-caret').removeClass('icon-menu-up').addClass('icon-menu-down');
    } else {
      $('.js-caret').removeClass('icon-menu-down').addClass('icon-menu-up');
    }
    this.triggerMethod('show:menu', !menuIsOpen);
  }
});
setGlobal('svs.sport.drawselector.views.DrawselectorHeader', DrawselectorHeader);

 })(window);